<script>
  import PrimaryNav from "../components/PrimaryNav.svelte";
export let title;
export let strapline;
// export let login;

let isMap = false;
let showNav = false;
let classIcon = 'icon-no-select';

$: if(showNav){
    classIcon = 'icon-select';
}else {
    classIcon = 'icon-no-select';
}

//body has to be set to id outerBody not sure what this is for
//bit messy for code as it relys heavily on the id
function pcheck(){
      let  v = document.getElementById("outerBody");
      
      if(v.classList.contains("map")){
        isMap= true;

      }else{
        isMap =false;
      }
};
pcheck();
  

  // let logInElement = "<a href='https://msc.fic.li' role='link' title='Sign in to your account'>Sign in</a> ";

</script>

<!-- <Route path ="/">This is the home page</Route> -->
<!-- <Router url ={"url"}> -->
 <div id="fic--top"></div> 
<header class="fic--ident" role="banner">
    <div class="fic--container">
      <div>
     
        <div class="fic--ident-name">
          <!-- <a href="/"><img src ="/img/US-LOGO-v1.png" alt="{title}" style="height:100px; width:300px"></a> -->
          <a href="/"><img src ="/img/logo57.png" alt="{title}" style="min-width: 200px; max-width: 320px"></a>
          
         <!-- <p class="fic--ident--subtitle">{strapline}</p>-->
         <!--breadcrumbs-->
        </div >

          <div class="fic--menu-display">
            <nav id="loginlink">
          
          {#if isMap}
              <a href='https://msc.fic.li' role='link' title='Sign in to your account'>Sign in</a>
          {/if}
          
            </nav>
          
            <a href="javascript:void(0);" class="fic--ident--menu icon-menu {classIcon}" on:click={function(){showNav = !showNav}}></a>
            
          <!-- <button class="fic--ident--menu icon-menu s-j--button" on:click={FICMenu}/> -->
          </div>
      </div>
    </div>
    <PrimaryNav bind:showNav={showNav} />

</header>
<!-- </Router> -->